import React, { useMemo, useEffect, useState } from "react";
import { Label, FormFeedback } from "reactstrap";
import Select from "react-select";
import { getMdas } from "common/services/mda.service";
import { normalize } from "common/lib/normalize";

const SelectMDA = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.mda && validation.errors.mda ? "red" : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.mda && validation.errors.mda ? "red" : "#ced4da",
      },
    }),
  };

  const region = validation.values.region?.value;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getMdas({
          pagination: {
            page: 1,
            pageSize: 500,
          },
          filters: {
            region: {
              id: region,
            },
          },
          populate: ["region"],
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading, region]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name} - ${el?.region?.name}`,
      };
    });
  }, [data]);

  return (
    <>
      <Label htmlFor="mda-field" className="form-label">
        Ministry / Department / Agency
      </Label>
      <Select
        isClearable
        name="mda"
        id="mda"
        value={validation.values?.mda?.value ? validation?.values?.mda : null}
        isSearchable
        placeholder="Select MDA"
        onChange={(value: any) => {
          validation.setFieldValue("mda", value);
          validation.setFieldError("mda", "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched("mda", true)}
        className={
          validation.touched.mda && validation.errors.mda ? "is-invalid" : ""
        }
        styles={customSelectStyles}
        loading={loading}
      />
      <FormFeedback>{validation.errors.mda?.value}</FormFeedback>
    </>
  );
};

export default SelectMDA;
